module.exports = __webpack_public_path__ + "img/3-3.cb0c35f8.jpg";